import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class BreadcrumbService {

    private breadcrumbUpdatedSource = new Subject<string[]>();
    public $breadcrumbUpdated = this.breadcrumbUpdatedSource.asObservable();
    private elements = [];

    public set studentName(name: string) {
        localStorage.setItem('studentName', name);
        this.updateBreadcrumb();
    }
    public get studentName(): string {
        return localStorage.getItem('studentName');
    }

    //public set classCode(classCode: string) {
    //    localStorage.setItem('classCode', classCode);
    //    this.updateBreadcrumb();
    //}

    //public get classCode() {
    //    return localStorage.getItem('classCode');
    //}

    public set coreTaskCode(coreTaskCode: string) {
        localStorage.setItem('coreTaskCode', coreTaskCode);
        this.updateBreadcrumb();
    }

    public get coreTaskCode() {
        return localStorage.getItem('coreTaskCode');
    }

    public set workProcessCode(workprocessCode: string) {
        localStorage.setItem('workProcessCode', workprocessCode);
        this.updateBreadcrumb();
    }

    public get workProcessCode() {
        return localStorage.getItem('workProcessCode')
    }

    constructor() { }

    public updateBreadcrumb() {
        this.breadcrumbUpdatedSource.next([this.studentName, this.coreTaskCode, this.workProcessCode]);
    }

    public examinationPreparationForm(formName) {
        this.breadcrumbUpdatedSource.next([this.studentName, 'Examinering voorbereiding', formName]);
    }
}



// WEBPACK FOOTER //
// ./src/app/breadcrumb/breadcrumb.service.ts